// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Ex0Rv","content":"RecentSearches_content__37hQ0"};